import React from 'react';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardEditorDumb';
import { Props } from '../ThumbView';

import s from './Tier.scss';

const TierThumbReactView: React.FC<Props> = ({ deviation, width, height }) => (
  <div className={s['root']} style={{ width, height }}>
    <TierPromotionCardSemiDumb
      width={width}
      height={height}
      deviation={deviation}
      ctaButton="subscribe"
    />
  </div>
);
TierThumbReactView.displayName = 'TierThumbReactView';

export default TierThumbReactView;
